<template>
	<!-- :allowClear="true" -->
		<a-auto-complete :data-source="tabData" :style="styles" :class="{'border_red': classFlag}" :placeholder="placeholder" @change="handleChange"
			@focus='focus' v-model="values" @search="handleSearch" :disabled='disabled'  >
				<!-- <a-input show-count maxlength="10" class="custom"/> -->
				<a-textarea
				style="resize:none;"
				class="custom"
				:maxlength="50"
				
				v-if="nameVlaue = 'hynr'"
				/>
			</a-auto-complete>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		model: {
			prop: 'value',
			event: 'child'
		},
		props: {
			styles: { //样式
				default: 'width: 200px',
			},
			route1: { //请求url
				default: '',
			},
			url: { //请求url
				default: '',
			},
			disabled:{
				default:false,
			},
			onhand: { //点击方式
				default: 'click',
			},
			val: { //回显
				default: '',
			},
			valstr: { //回显
				default: '',
			},
			valonce: { //回显
				default: '',
			},
			params: {
				default: {
					type: 'industrys'
				},
			},
			placeholder: {
				default: '',
			},
			nameVlaue: {
				default: '',
			},
			zz: {
				default: '',
			},
			openfirst: {
				default: false,
			},
			classFlag: {
				default: false,
			},
			classFlag2: {
				default: false,
			},
		},
		data() {
			return {
				//下啦列表
				tabData: [],
				//input
				values: '',
				//接口参数
				tableparams: {}
			}
		},
		watch: {
			val: {
				immediate: true,
				handler(ev) {
					if (ev) {
						setTimeout(()=>{
							this.handleChange(ev)
						},100)
					}
				}
			},
			valstr: {
				immediate: true,
				deep:true,
				handler(ev) {
					console.log(ev)
					if (ev) {
						let _this = this
						setTimeout(()=>{
						_this.values = ev
						_this.$emit('child', _this.values)
						},800)
					}
				}
			},
			values: {
				deep:true,
				immediate: true,
				handler(ev) {
					if(this.zz == 'zz'){
						this.values = this.values.replace(/[,]+/g, '')
					}
				}
			},
			onclick:{
				deep:true,
				immediate: true,
				handler(ev) {
				}
			}
		},
		mounted() {
			console.log(this.nameVlaue);
			for (let key in this.params) {
				this.tableparams[key] = this.params[key]
			}
			setTimeout(()=>{
				this.handleChange(this.valonce)
			},500)
		},
		methods: {
			zerostr(){
				this.values = ''
			},
			getdata(val) {
				this.tableparams['searchstr'] = val||''
				this.$ajax({
					method: 'post',
					url: this.url,
					headers: {
						token: this.$store.state.token
					},
					data: this.tableparams
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.tabData = res.data.result
						if (this.route1 == 'hk_shangshi') {
							this.tabData = []
							res.data.result.forEach(item => {
								this.tabData.push(item.industry)
							});
						}
						if (this.route1 == 'sqjq_bm') {
							this.tabData = []
							res.data.result.forEach(item => {
								if (item) {
									this.tabData.push(item)
								}
							});
						}
						if (this.route1 == 'zqzhSeach') {
							this.tabData = res.data.securityAccounts
						}
						if(this.openfirst && !this.valonce && this.tabData.length){
							this.values = this.tabData[0]
						}
						
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			focus(){
				this.getdata()
			},
			handleSearch(val) {
				this.values = val
				this.tabData = []
				if(val){
					this.getdata(val)
				}
			},
			handleBlur(val) {
				// console.log('handleBlur',val)
				// this.$emit('child', this.values)
			},
			handleChange(value) {
				let _this = this
				_this.classFlag = false
				_this.tabData = !value || value.indexOf('@') >= 0 ?
					[] :
					_this.tabData;

				_this.values = value
				_this.$emit('child', _this.values,_this.classFlag)
			},
		}
	}
</script>

<style lang='scss'>
		.ant-select-dropdown-menu-item{
			font-size: .75rem !important;
		}
</style>
